// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {deleteReportLayout} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateLayoutModal = isOpen => ({
    isOpen,
    type: actions.UPDATE_LAYOUT_MODAL
});

export const updateExistingLayout = (property, layoutName, value) => ({
    layoutName,
    property,
    type: actions.UPDATE_EXISTING_LAYOUT,
    value
});

export const deleteLayout = (reportName, layoutName) =>

    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteReportLayout(reportName, layoutName);

            const currentLayouts = getState().reportVariant.layouts;

            const defaultLayout = getState().reportVariant.layouts.find(layout => layout.name === '');

            const data = currentLayouts.filter(layout => layout.name !== layoutName);

            dispatch({
                data,
                selectedLayout: defaultLayout,
                type: actions.UPDATE_REPORT_GRID_LAYOUTS
            });

            dispatch(updateLayoutModal(false));

            successAlertBar(translate('LAYOUT_DELETED_SUCCESSFULLY'));

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/update-layout-modal.js